import React from "react";
import "./Table.css";

export const ComplexTable = (props) => {
  return (
    <div className="table-container">
      <table className="responsive-table">
        <thead>
          <tr>
            <th rowSpan="2">Registration Type and fees</th>
            <th colSpan="2">Onsite Presentation</th>
            <th colSpan="2">Online Presentation</th>
            <th>Additional pages fee</th>
          </tr>
          <tr>
            <th>Early Bird <br />{props.currencytype}</th>
            <th>On Desk/Late registration <br />{props.currencytype}</th>
            <th>Early Bird <br />{props.currencytype}</th>
            <th>On Desk/Late registration <br />{props.currencytype}</th>
            <th>Extra charge per page <br />{props.currencytype}</th>
          </tr>
        </thead>
        <tbody>
          {props.col1.map((col1, index) => {
            return (
              <tr>
                <th>{props.col1[index]}</th>
                <td>{props.col2[index]}</td>
                <td>{props.col3[index]}</td>
                <td>{props.col4[index]}</td>
                <td>{props.col5[index]}</td>
                <td>{props.col6[index]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
